import React from "react";
import { toast } from "react-toastify";
import { FiKey, FiArchive, FiPlusSquare } from "react-icons/fi";

import TagButton from "../components/primatives/TagButton";
import Textarea from "../components/primatives/Textarea";
import ActionButton from "../components/primatives/ActionButton";
import Section from "../components/primatives/Section";
import SectionHeader from "../components/primatives/SectionHeader";

class Insert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      theKey: "",
      theVal: "",
      isLoading: false,
    };
  }

  setTheKey = (theKey) => {
    this.setState({ theKey: theKey.toUpperCase() });
  };

  setTheVal = (theVal) => {
    this.setState({ theVal });
  };

  addKeyPair = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    try {
      let put = this.props.helpers.put();
      const { theKey, theVal } = this.state;
      await put.add(theKey, theVal);
      // refresh ram..
      this.props.helpers.refreshApp();
      // redirect to home
      this.props.history.push("/");
      toast.success("Key-value stored on chain.");
    } catch (e) {
      //console.log(e);
      toast.error(e.toString());
      this.setState({ isLoading: false });
    }
  };

  render() {
    const put = this.props.helpers.put();
    const { setTheKey, setTheVal, addKeyPair } = this;
    const { theKey, theVal } = this.state;

    // ref for key input focus.
    const keyInput = React.createRef();

    return (
      <div>
        <form onSubmit={addKeyPair}>
          <Section>
            <SectionHeader>
              <FiKey /> Enter a <b className="text-indigo-700">key</b> name.
            </SectionHeader>
            <div className="text-sm mb-2">This unique name will identify your data.</div>
            <input
              ref={keyInput}
              required={true}
              placeholder="MY_NEW_KEY"
              onChange={(e) => setTheKey(e.target.value)}
              value={theKey}
              className="font-extrabold shadow-inner text-2xl bg-white border rounded w-full p-2 text-indigo-700 uppercase focus:shadow-md focus:outline-none"
              type="text"
            />
            <div className="mt-2 text-sm">
              <TagButton
                onClick={(e) => {
                  e.preventDefault();
                  keyInput.current.focus();
                  setTheKey("FEATURE_");
                }}
              >
                feature
              </TagButton>
              <TagButton
                onClick={(e) => {
                  e.preventDefault();
                  keyInput.current.focus();
                  setTheKey("RULE_");
                }}
              >
                rule
              </TagButton>
              <TagButton
                onClick={(e) => {
                  e.preventDefault();
                  keyInput.current.focus();
                  setTheKey("CONFIG_");
                }}
              >
                config
              </TagButton>
            </div>
          </Section>

          <Section>
            <SectionHeader>
              <FiArchive /> Assign a <b className="text-indigo-700">value</b>.
            </SectionHeader>
            <div className="text-sm mb-2">Return data when referenced by key.</div>

            <Textarea
              required={true}
              placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
              onChange={(e) => setTheVal(e.target.value)}
              value={theVal}
            />
            <div className="mt-1 text-sm">
              <TagButton
                onClick={(e) => {
                  e.preventDefault();
                  setTheVal("true");
                }}
              >
                true
              </TagButton>
              <TagButton
                onClick={(e) => {
                  e.preventDefault();
                  setTheVal("false");
                }}
              >
                false
              </TagButton>
              <TagButton
                onClick={(e) => {
                  e.preventDefault();
                  setTheVal("enabled");
                }}
              >
                enabled
              </TagButton>
              <TagButton
                onClick={(e) => {
                  e.preventDefault();
                  setTheVal("disabled");
                }}
              >
                disabled
              </TagButton>
              <TagButton
                onClick={(e) => {
                  e.preventDefault();
                  setTheVal("100");
                }}
              >
                100
              </TagButton>
            </div>
          </Section>

          <div className="mt-4 mb-1 text-sm w-full text-center">
            This new key requires 🗄<b>{put.estimate.add(theKey, theVal)}</b> and
            📝<b>1</b>.
          </div>
          <ActionButton type="submit" isLoading={this.state.isLoading}>
            <FiPlusSquare style={{color:'white'}} /> Add key-value pair.
          </ActionButton>
        </form>
      </div>
    );
  }
}

export default Insert;
